import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';
import { AsmUi } from '@asm/const';
import { AsmComponentService, AsmService, CsAgentAuthService } from '@asm/feature';
import { AuthService, GlobalMessageService, GlobalMessageType, RoutingService, User } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { AsmSessionTimerComponent } from '../asm-session-timer';
import { AsmToggleUiComponent } from '../asm-toggle-ui';
import { CSAgentLoginFormComponent } from '../csagent-login-form';
import { CustomerEmulationComponent } from '../customer-emulation';
import { CustomCustomerSelectionComponent } from '../customer-selection';

@Component({
  selector: 'ui-asm-main-ui',
  templateUrl: './asm-main-ui.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    CustomCustomerSelectionComponent,
    AsmToggleUiComponent,
    AsmSessionTimerComponent,
    CustomerEmulationComponent,
    CSAgentLoginFormComponent,
  ],
})
export class CustomAsmMainUiComponent implements OnInit {
  customerSupportAgentLoggedIn$: Observable<boolean>;
  csAgentTokenLoading$: Observable<boolean>;
  customer$: Observable<User | undefined>;
  isCollapsed$: Observable<boolean>;

  @HostBinding('class.hidden') disabled = false;

  protected startingCustomerSession = false;

  constructor(
    protected authService: AuthService,
    protected csAgentAuthService: CsAgentAuthService,
    protected userAccountFacade: UserAccountFacade,
    protected asmComponentService: AsmComponentService,
    protected globalMessageService: GlobalMessageService,
    protected routingService: RoutingService,
    protected asmService: AsmService,
  ) {}

  ngOnInit(): void {
    this.customerSupportAgentLoggedIn$ = this.csAgentAuthService.isCustomerSupportAgentLoggedIn();
    this.csAgentTokenLoading$ = this.csAgentAuthService.getCustomerSupportAgentTokenLoading();
    this.customer$ = this.authService.isUserLoggedIn().pipe(
      switchMap((isLoggedIn) => {
        if (isLoggedIn) {
          this.handleCustomerSessionStartRedirection();

          // eslint-disable-next-line deprecation/deprecation
          return this.userAccountFacade.get();
        } else {
          return of(undefined);
        }
      }),
    );
    this.isCollapsed$ = this.asmService
      .getAsmUiState()
      .pipe(map((uiState: AsmUi) => (uiState.collapsed === undefined ? false : uiState.collapsed)));
  }

  loginCustomerSupportAgent({ userId, password }: { userId: string; password: string }): void {
    this.csAgentAuthService.authorizeCustomerSupportAgent(userId, password);
  }

  logout(): void {
    this.asmComponentService.logoutCustomerSupportAgentAndCustomer();
  }

  startCustomerEmulationSession({ customerId }: { customerId?: string }): void {
    if (customerId) {
      this.csAgentAuthService.startCustomerEmulationSession(customerId);
      this.startingCustomerSession = true;
    } else {
      this.globalMessageService.add({ key: 'asm.error.noCustomerId' }, GlobalMessageType.MSG_TYPE_ERROR);
    }
  }

  hideUi(): void {
    this.disabled = true;
    this.asmComponentService.unload();
  }

  protected handleCustomerSessionStartRedirection(): void {
    this.asmComponentService
      .isCustomerEmulationSessionInProgress()
      .pipe(take(1))
      .subscribe((isCustomerEmulated) => {
        if (this.startingCustomerSession && isCustomerEmulated) {
          this.startingCustomerSession = false;
          this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
          this.routingService.go('/');
        }
      });
  }
}
